import React, { useState, useEffect } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TableMyshop from './report/TableMyshop';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import ModalItemshop from './modal/ModalItemshop';
import { ItemShopData, fetchDropdownData, fatchZoomData } from '../../services/apifp';
import { ContentHeader } from '@components';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { logoutUser } from '@store/reducers/auth';
import SignatureCD from './SignatureCD';
import { useSearchParams } from 'react-router-dom';

const MyItems = () => {
  const user = useSelector((state: any) => state.auth.currentUser);

  const [searchParams, setSearchParams] = useSearchParams();
  const [shop_id, setShop_id] = useState(searchParams.get('shop_id') || '');
  // const [data, setData] = useState([]);
  const [data, setData] = useState<any[]>([]); // ✅ กำหนดค่าเริ่มต้นเป็นอาร์เรย์
  const [page, setPage] = useState(0);
  const [key, setKey] = useState('history');
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [dropdowns, setDropdowns] = useState(null);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    loadData();

  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const shopData = await ItemShopData();

      if (!shopData || !Array.isArray(shopData)) {
        console.error("⚠️ API ส่งข้อมูลผิดพลาด:", shopData);

        // 🚀 ออกจากระบบและไปที่หน้า Login
        dispatch(logoutUser());
        window.location.href = "/login";
        return;
      }

      console.log("✅ ข้อมูลที่ได้รับจาก API:", shopData);
      setData(shopData);
      setShowModal(false);

      if (shop_id !== "") {
        handleViewClick(shopData.find(item =>(item.SHOP_ID === shop_id)));
      }
    } catch (error) {
      console.error("❌ โหลดข้อมูลล้มเหลว:", error);

      // 🚀 ออกจากระบบและไปที่หน้า Login
      dispatch(logoutUser());
      window.location.href = "/login";
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (showModal) {
      const loadDropdowns = async () => {
        try {
          setDropdownLoading(true);
          const dropdownData = await fetchDropdownData();
          setDropdowns(dropdownData);
        } catch (error) {
          console.error('Error fetching dropdown data:', error);
          toast.error('ไม่สามารถโหลดข้อมูล Dropdown ได้');
          dispatch(logoutUser());
          // navigate('/login');
          window.location.href = '/login';
        } finally {
          setDropdownLoading(false);
        }
      };

      loadDropdowns();
    }
  }, [showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleViewClick = (item) => {
    console.log("🔎 Item ที่ถูกคลิก:", item); // ตรวจสอบค่า `item`

    if (!item?.SHOP_ID) {
      console.error("⚠️ shopId เป็น undefined หรือ null!");
      toast.error("⚠️ ไม่พบข้อมูลร้านค้า");
      return;
    }

    setSelectedItem(item);
    setShowModal(true);
  };

  const onZoom = async (SHOP_ID) => {
    console.log("🔎 Item ที่ถูกคลิก:", SHOP_ID); // ตรวจสอบค่า `item`

    const res = await fatchZoomData(SHOP_ID);
    return res;
  };

  return (
    <div>
      {/* <h3>ประวัติการลงทะเบียนร้านค้า</h3> */}
      <ContentHeader title="ประวัติการลงทะเบียนร้านค้า" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                <Tab eventKey="history" title="ประวัติ">
                  {loading ? (
                    <p>กำลังโหลดข้อมูล...</p>
                  ) : (
                    <TableMyshop show={true}
                      setFilter={setFilter}
                      filter={filter}
                      items={data.map((e: any) => ({ ...e, _idemp: user.ID_EMP, _token: localStorage.getItem('gatekeeper_token') }))} page={page}
                      onPageChange={(newPage) => setPage(newPage)}
                      onToggle={handleViewClick}
                      onZoom={onZoom}
                    />


                  )}
                </Tab>

                <Tab eventKey="add-signature" title="เพิ่มลายเซ็นของฉัน">

                  <SignatureCD
                  />
                </Tab>
              </Tabs>

              {/* 🛠️ Modal ที่มี Header ที่นี่ */}
              <Modal show={showModal}
                className="modal-fullscreen"
                onHide={handleCloseModal}
                >

                <Modal.Header closeButton>
                  <Modal.Title>รายละเอียดร้านค้าของฉัน</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {selectedItem ? (
                    <ModalItemshop
                      shopId={selectedItem.SHOP_ID} // ✅ ส่งเฉพาะ `SHOP_ID`
                      item={selectedItem}
                      // show={showModal}
                      dropdowns={dropdowns || {}}
                      // loadData={loadData}
                      loadData={loadData}
                    // onSave={(id, updatedItem) => {
                    //   setData((prevData: any) =>
                    //     prevData.map((shop: any) =>
                    //       shop.SHOP_ID === id ? { ...shop, ...updatedItem } : shop
                    //     )
                    //   );
                    
                    // }}
                    // onHide={handleCloseModal}
                    />
                  ) : (
                    <p>กำลังโหลดข้อมูลร้านค้า...</p> // ✅ แสดงข้อความขณะโหลด
                  )}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyItems;
